















































































































































































































































































































































































































































import { defineComponent, toRefs } from '@nuxtjs/composition-api'
/* eslint-disable no-console */
import { mapGetters, mapState } from 'vuex'
import {
  faCheck,
  faArrowRight,
  faAngleDoubleRight,
  faPaperPlane,
  faTimes,
  faChevronDown,
  faChevronUp,
  faPhone,
  faEnvelope,
  faCamera
} from '@fortawesome/free-solid-svg-icons'
import { faImage as farImage } from '@fortawesome/free-regular-svg-icons/faImage'
import vClickOutside from 'v-click-outside'
import { format } from '~/utils/date'
import CFormMixin from '~/components/shared/configurable/mixin/CFormMixin.vue'
import CEmailInput from '~/components/shared/configurable/form/input/CEmailInput.vue'
import CInternationalTelephoneInput from '~/components/shared/configurable/form/input/CInternationalTelephoneInput.vue'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import CEditableDiv from '~/components/shared/configurable/form/input/CEditableDiv.vue'
import CMiniMessageEntry from '~/components/shared/configurable/message/CMiniMessageEntry.vue'
import CMessageAvatar from '~/components/shared/configurable/message/CMessageAvatar.vue'
import CFileUploadMixin from '~/components/shared/configurable/mixin/CFileUploadMixin.vue'
import CGiphySearch from '~/components/shared/configurable/CGiphySearch.vue'
import CPendingAttachments from '~/components/shared/configurable/message/CPendingAttachments.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import CUserAvatarUploader from '~/components/shared/configurable/user/avatar/CUserAvatarUploader.vue'
import CReportModal from '~/components/shared/configurable/modal/CReportModal.vue'
import { UserType } from '~/models/user/types'
import { FallbackWidgetRenderResult } from '~/models/recaptcha/types'
import sanitizeHtml from 'sanitize-html'
import { defaultSanitizeHtmlOptions } from '~/constants/sanitization'
import { APP_NS } from '~/store/modules/shared/app/state'
import RecaptchaService from '~/services/recaptcha/RecaptchaService'
import MessageReportService from '~/services/report/message/MessageReportService'
import CInfiniteScroll from '~/components/shared/configurable/infinite-scroll/CInfiniteScroll.vue'
import TradesMatchAvatars from '~/components/car/trades/TradesMatchAvatars.vue'
import ClassifiedOfferPrice from '~/components/car/offers/ClassifiedOfferPrice.vue'
import ClassifiedOfferActionButtons from '~/components/car/offers/ClassifiedOfferActionButtons.vue'
import MakeOfferModal from '~/components/shared/classified/offers/MakeOfferModal.vue'
import { ClassifiedOfferEntry, OfferState } from '~/models/classified/offers'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { useWebSocket } from '~/compositions/web-socket'
import { getCurrentInstance } from '@vue/composition-api'
import { changeFaviconNotification } from '~/utils/dom'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import MarketplaceOrderInThread from '~/components/car/marketplace/order/MarketplaceOrderInThread.vue'
import { toCamelCase } from '~/utils/object'

export default defineComponent({
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    MarketplaceOrderInThread,
    MakeOfferModal,
    ClassifiedOfferActionButtons,
    ClassifiedOfferPrice,
    TradesMatchAvatars,
    CInfiniteScroll,
    CMiniMessageEntry,
    CMessageAvatar,
    CReportModal,
    CEmailInput,
    CInternationalTelephoneInput,
    CFormError,
    CEditableDiv,
    CGiphySearch,
    CPendingAttachments,
    CUserAvatarUploader
  },
  mixins: [CFormMixin, CFileUploadMixin],
  props: {
    messageThread: { type: Object, required: true, default: null },
    isForGuest: { type: Boolean, required: false, default: false },
    inMiniThread: { type: Boolean, required: false, default: false },
    ownedDealers: {
      type: Array,
      default() {
        return []
      }
    },
    query: { type: String, required: false, default: '' },
    initialHighlight: { type: Number, required: false, default: null },
    attachmentsPerMessage: { type: Number, required: false, default: 8 },
    acceptedFiles: {
      type: Array,
      default: () => ['image/jpeg', 'image/png']
    },
    foundMessages: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    tradesParticipantName: {
      type: String,
      required: false,
      default: ''
    },
    inModal: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      icons: {
        check: faCheck,
        paperPlane: faPaperPlane,
        arrowRight: faArrowRight,
        angleDoubleRight: faAngleDoubleRight,
        times: faTimes,
        chevronUp: faChevronUp,
        chevronDown: faChevronDown,
        phone: faPhone,
        envelope: faEnvelope,
        camera: faCamera,
        image: farImage
      },
      pageNum: 1,
      loading: false,
      messages: [],
      pagination: null,
      firstLoad: true,
      form: {},
      schema: {},
      messageBuffer: null,
      sendTimeout: null,
      hasPending: false,
      plusReplies: 0,
      plusPages: 0,
      method: 'post',
      showRecaptcha2: false,
      recaptcha2Loaded: false,
      messageText: '',
      infiniteOffset: 30,
      loadMyDetails: false,
      myDetailsShown: false,
      gifShown: false,
      replyFetched: false,
      afterDelete: null,
      highlightAfterLoad: -1,
      pageOfDeleted: null,
      disableInput: false,
      retrying: false,
      disableSend: false,
      hasNewMessages: false,
      reportModalVisible: false,
      messageToReport: null,
      lastTs: this.messageThread.last_message_ts,
      placeHolderText: this.$t('type a message'),
      buttonText: this.$t('type a message'),
      highlight: this.initialHighlight || null,
      dropOver: false,
      filesToSend: [],
      gifToSend: null,
      deleteQueueList: [],
      overCharLimit: false,
      showMakeOfferModal: false
    }
  },
  computed: {
    ...mapState(USER_NS, {
      userId: 'id',
      userType: 'type',
      userName: 'username',
      avatar: 'avatar'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    }),
    ...mapGetters(APP_NS, {
      isPlot: 'isPlot'
    }),
    url() {
      return `/api/account/messages/${this.messageThread.id}/reply/`
    },
    notAbleToSend() {
      return (
        ((this.messageText === '' ||
          sanitizeHtml(this.messageText, defaultSanitizeHtmlOptions) === '') &&
          this.filesToSend.length === 0) ||
        this.disableSend ||
        this.uploading ||
        this.isSystemMsg ||
        this.overCharLimit
      )
    },
    shouldShowMyDetails() {
      return !this.isForGuest && !this.isSystemMsg
    },
    inputPlaceholder() {
      if (this.isSystemMsg) {
        return this.$t('you cannot reply to a system message')
      }
      if (this.participantDeleted) {
        return this.$t('you cannot reply to that user')
      }
      return this.placeHolderText
    },
    buttonTitle() {
      if (this.messageText.length === 0) {
        if (this.isSystemMsg) {
          return this.$t('you cannot reply to a system message')
        } else {
          return this.buttonText
        }
      }

      return this.$t('reply')
    },
    isManager() {
      // if owndealers.length == 1 it means we are not really a manager, just a user (in car1 terms at least)
      if (this.ownedDealers.length > 1 || this.userType === UserType.ADMIN) {
        return true
      }

      return false
    },
    isSystemMsg() {
      return (
        this.messageThread.owner.system || this.messageThread.participant.system
      )
    },
    participantDeleted() {
      return this.messageThread.participant.is_deleted
    },
    participantHasTelephone() {
      return (
        this.messageThread.participant.telephone &&
        this.messageThread.participant.telephone.telephone
      )
    },
    showOfferBlock() {
      return (
        this.messageThread.topic === 'classified_offer' &&
        this.messageThread.offer
      )
    },
    telToCall() {
      if (this.participantHasTelephone) {
        if (parseInt(this.messageThread.participant.telephone.code) !== 30) {
          return (
            '+' +
            this.messageThread.participant.telephone.code +
            '' +
            this.messageThread.participant.telephone.telephone
          )
        }

        return this.messageThread.participant.telephone.telephone
      }

      return ''
    },
    nullParticipant() {
      return this.messageThread.participant.id === null
    },
    noParticipantWithMail() {
      return this.nullParticipant && this.messageThread.participant.email
    },
    nullParticipantEmail() {
      return (
        this.messageThread.participant.email === '' ||
        this.messageThread.participant.email === null ||
        !this.messageThread.participant.email
      )
    },
    allowReplies() {
      return this.messageThread.participant.allow_replies
    },
    msgStatus() {
      return this.messageThread.read ? 'read' : 'unread'
    },
    messagesExist() {
      return this.messages && this.messages.length > 0
    },
    paginationPages() {
      if (this.pagination) {
        return Math.ceil(this.pagination.total / this.pagination.per_page)
      }
      return 0
    },
    lastPageLoaded() {
      if (this.pagination && this.pageNum === this.paginationPages) {
        return true
      }
      return false
    },
    highlightPosition() {
      return this.foundMessagesIDs.indexOf(this.highlight) + 1
    },
    foundMessagesIDs() {
      const onlyIDs = []
      for (let i = 0; i < this.foundMessages.length; i++) {
        onlyIDs.push(this.foundMessages[i].id)
      }
      return onlyIDs
    },
    messageUserId() {
      if (!this.isManager && this.ownedDealers.length === 1) {
        return this.ownedDealers[0].id
      }

      return this.userId
    },
    groupedMessages() {
      if (this.messages.length) {
        const groups = this.messages.reduce(function(r, a) {
          r[a.group.toString()] = r[a.group.toString()] || []
          r[a.group.toString()].push(a)
          return r
        }, {})

        const result = []
        for (const group in groups) {
          if (parseInt(group) >= 0) {
            result.push(groups[group])
          } else {
            result.unshift(groups[group])
          }
        }

        return result.reverse()
      }

      return []
    },
    messageReportService() {
      const messageReportService = this.$dep(MessageReportService)

      return messageReportService
    },
    lastMessageId() {
      return this.messages[this.messages.length - 1]?.id
    },
    OfferState() {
      return OfferState
    }
  },
  watch: {
    hasPending(value) {
      this.$emit('pending-status', value)
    },
    initialHighlight(val) {
      if (val) {
        this.highlight = val
        this.goToMsg(this.highlight)
      }
    },
    hasNewMessages(val) {
      if (process.client) {
        changeFaviconNotification(val)
      }
    }
  },
  updated() {
    this.$emit('updated')
  },
  mounted() {
    if (this.participantDeleted) {
      this.disableInput = true
    }
    this.fetchMessages()
    window.addEventListener('focus', this.onWindowFocus)
  },
  destroyed() {
    this.closeRelay()
    window.removeEventListener('focus', this.onWindowFocus)
  },
  methods: {
    toCamelCase,
    triggerInput() {
      const input = this.$refs['attatchment-input']
      input.value = null
      input.click()
    },
    fetchMessagesAfterDelete(msg) {
      this.pageNum = 1
      this.pageOfDeleted = msg.page

      this.clearMessages()
      this.afterDelete = msg.id
      if (msg.page === 1) {
        // then dont scroll like crazy
        this.firstLoad = true
      }
      this.fetchMessages()
    },
    fetchNewMessages() {
      if (!this.loading) {
        this.pageNum = 1
        this.firstLoad = true
        this.fetchMessages()
      }
    },
    clearMessages() {
      this.messages = []
      this.plusReplies = 0
      this.plusPages = 0
    },
    fetchMessages() {
      this.loading = true
      this.disableSend = true
      const fetchPageNum = this.hasPending ? 1 : this.pageNum + this.plusPages

      this.$axios
        .get(`/api/account/messages/${this.messageThread.id}/`, {
          params: {
            pg: fetchPageNum,
            exclude_ids: this.afterDelete
          }
        })
        .then(response => {
          if (response.status === 200 && !this._isDestroyed) {
            if (this.firstLoad && (this.hasNewMessages || this.hasPending)) {
              // reset messages if we are fetching for new messages or for reply (?)
              this.hasPending = false
              this.clearMessages()
            }

            // group calculation first:
            let responseRows = response.data.data.messages.rows

            if (this.messageThread.offer) {
              // probably an offers thread
              responseRows = responseRows.map((r: any) => {
                if (r.bid) {
                  // transform bid to offer
                  const bid = { ...r.bid }
                  const offer = { ...this.messageThread.offer }
                  offer.latestBid = bid

                  delete r.bid
                  return { ...r, offer }
                }
                return r
              })

              if (fetchPageNum === 1 && this.firstLoad) {
                // if this is a fetch for new messages
                // find the last message with offer and update the thread offer

                const lastIndexWithOffer = responseRows.findIndex(
                  (r: any) => r.offer
                )
                if (lastIndexWithOffer >= 0) {
                  this.$emit(
                    'update-offer',
                    responseRows[lastIndexWithOffer].offer
                  )
                }
              }
            }

            if (!responseRows || responseRows.length === 0) {
              this.invalidateThread()
            }

            let latestGroup = 0
            if (this.messages.length) {
              latestGroup = this.messages[0].group
              if (
                this.messages[0].sender_user_id !==
                  responseRows[0].sender_user_id &&
                !this.hasPending
              ) {
                latestGroup++
              }
            }

            for (let i = 0; i < responseRows.length; i++) {
              if (i === 0 && this.hasPending) {
                latestGroup = this.messages[this.messages.length - 1].group
              }
              responseRows[i].group = latestGroup
              responseRows[i].page = fetchPageNum

              const increase =
                i + 1 <= responseRows.length - 1 &&
                responseRows[i].sender_user_id !==
                  responseRows[i + 1].sender_user_id

              if (increase) {
                latestGroup++
              }
            }
            // end of group calculation

            // reversed because we want that messenger style
            const pageMessages = responseRows.slice().reverse()

            for (let i = 0; i < pageMessages.length; i++) {
              pageMessages[i].page = this.hasPending
                ? 1
                : this.pageNum + this.plusPages
            }

            if (this.hasPending) {
              // doing it this way to make computed groups to update
              this.messages.splice(-1, 1)
              this.messages.push(pageMessages[pageMessages.length - 1])
            } else if (this.messages.length) {
              for (
                let i = pageMessages.length - 1 - this.plusReplies;
                i >= 0;
                i--
              ) {
                this.messages.unshift(pageMessages[i])
              }
            } else {
              this.messages = pageMessages
            }

            this.pagination = response.data.data.messages.pagination

            this.loading = false

            if (this.afterDelete && fetchPageNum >= this.pageOfDeleted) {
              this.afterDelete = null
              this.pageOfDeleted = null
            }

            let previousScrollHeight = null
            if (this.$refs.messagesContainer) {
              previousScrollHeight = this.$refs.messagesContainer.scrollHeight
            }

            if (this.highlight > 0 || this.highlightAfterLoad > 0) {
              if (this.firstLoad) {
                setTimeout(() => {
                  this.goToMsg(this.highlight)
                }, 200) // panel transition time
              } else {
                this.$nextTick(() => {
                  if (this.highlightAfterLoad > 0) {
                    this.goToMsg(this.highlightAfterLoad)
                    this.highlightAfterLoad = -1
                  } else {
                    this.goToMsg(this.highlight)
                  }
                })
              }
            }

            // if this is the first load scroll to bottom else scroll to first msg
            if (!this.hasPending) {
              if (this.firstLoad) {
                this.scrollToBottom()
              } else {
                this.$nextTick(() => {
                  const msgCont = this.$refs.messagesContainer

                  if (
                    this.messages.length &&
                    msgCont &&
                    msgCont.scrollHeight > msgCont.clientHeight
                  ) {
                    msgCont.scrollTop =
                      msgCont.scrollHeight -
                      previousScrollHeight +
                      this.infiniteOffset
                  }
                })
              }
            } else {
              this.scrollToBottom()
            }

            this.hasPending = false
            this.disableSend = false
            this.hasNewMessages = false

            if (this.retrying) {
              this.retrying = false
              this.disableInput = false
            }

            const respThread = response.data.data.thread
            if (respThread && respThread.last_message_ts) {
              this.lastTs = respThread.last_message_ts
              this.$emit('thread-update', respThread)
            }

            this.openRelay()
            if (document.hasFocus()) {
              this.$emit('messages-read')
            }
          }

          // i dont like this but seems like this is the only way
          if (this.firstLoad) {
            setTimeout(() => {
              this.firstLoad = false
            }, 600)
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    invalidateThread() {
      this.$axios
        .post(`/api/account/messages/${this.messageThread.id}/invalidate/`)
        .then(response => {
          if (response.status === 200) {
            this.$emit('close-clicked', this.messageThread)
            this.$snackbar.error(this.$t('this thread has been deleted'))
            this.$emit('thread-invalidated')
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    onWindowFocus() {
      if (!this.messageThread.read) {
        this.$emit('messages-read')
      }
    },
    onNewMessages() {
      this.hasNewMessages = true

      // update thread as unread so that the general alert is triggered
      this.messageThread.read = false
      this.$emit('thread-update', this.messageThread)
      this.$emit('new-messages')
      this.scrollToBottom()

      if (process.client) {
        // auto fetch messages current tab is focused
        setTimeout(this.fetchNewMessages, 400)
      }
    },
    DeleteMessage(msgId) {
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].id === msgId) {
          const index = i
          const messageToDelete = this.messages[i]
          this.$axios
            .delete(
              `/api/account/messages/${this.messageThread.id}/${this.messages[index].id}/`
            )
            .then(response => {
              if (response.status === 200) {
                // get the react magic
                this.messages.splice(index, 1)

                if (this.messages.length === 0) {
                  this.$emit('thread-just-empty')
                  this.$emit('close-clicked', this.messageThread)
                } else {
                  this.fetchMessagesAfterDelete(messageToDelete)
                }
              }
            })
            .catch(error => {
              console.error(error)
            })
        }
      }
    },
    idMine(id) {
      if (this.userId === id) {
        return true
      } else if (this.ownedDealers.length) {
        for (let i = 0; i < this.ownedDealers.length; i++) {
          if (this.ownedDealers[i].id === id) {
            return true
          }
        }
        return false
      }

      if (
        this.userType === UserType.ADMIN &&
        id === this.messageThread.owner.id
      ) {
        return true
      }
      return false
    },
    async onError(errors) {
      this.disableSend = false

      if (errors?.recaptcha_token && !this.showRecaptcha2) {
        this.showRecaptcha2 = true
        this.scrollToBottom()
        this.disableSend = true
        const recaptchaService = this.$dep(RecaptchaService)

        if (!this.recaptcha2Loaded) {
          this.recaptcha2Loaded = true
          await this.$nextTick()
          const {
            token
          }: FallbackWidgetRenderResult = await recaptchaService.renderFallbackWidget(
            `recaptchav2-reply-${this.messageThread.id}`
          )
          this.disableSend = false
          this.form.recaptcha_token = {
            v: 2,
            token
          }

          if (this.hasPending) {
            this.messageText = ''
            this.retryPendingMessage()
          }
        } else {
          recaptchaService.reset()
        }
      }

      if (errors?.telephone || errors?.name || errors?.email) {
        this.showMyDetails()
      }

      if (errors?.body && this.hasPending) {
        // if we have errors on body discard the pending message
        this.messages.splice(this.messages.length - 1, 1)
        this.hasPending = false
        this.messageBuffer = null
      }

      if (this.hasPending) {
        this.messages[this.messages.length - 1].id = 'failed'
        this.$nextTick(function() {
          document
            .getElementById('msg-' + this.messageThread.id + '-failed')
            .scrollIntoView()
        })
      }
    },
    onResponseError(response) {
      if (response.response.data.error) {
        this.errors = { message: response.response.data.error.message }
      } else {
        this.errors = {
          message: this.$t('an error occurred please try again later')
        }
      }

      if (this.hasPending) {
        this.messages[this.messages.length - 1].id = 'failed'
        this.$nextTick(function() {
          document
            .getElementById('msg-' + this.messageThread.id + '-failed')
            .scrollIntoView()
        })
      }
    },
    messageImageLoad(gindex, mindex) {
      if (
        this.pageNum === 1 ||
        (gindex === this.groupedMessages.length - 1 &&
          mindex >= this.groupedMessages[gindex].length - 3) // give a bit of offset, aka last three messages
      ) {
        this.scrollToBottom()
      }
    },
    checkFilesOnInput(currentFiles) {
      if (currentFiles.length > this.attachmentsPerMessage) {
        alert(
          this.$t(
            'you can upload only %s files per message, please try again with fewer files'
          ).replace('%s', this.attachmentsPerMessage)
        )

        return false
      }

      return true
    },
    onPostSuccess(response, theFile) {
      if (response.data.data) {
        theFile.approved = true
        theFile.attachmentData = response.data.data
        if (theFile.type) {
          theFile.attachmentData.tags = [theFile.type]
        }
        theFile.filename = response.data.data.name
      }
    },
    afterAllRequestsComplete() {
      this.afterQueueComplete()

      this.filesToSend = this.files
      this.disableSend = false

      this.deletedCleaner()
    },
    queueDeleteFile(indx) {
      this.files[indx].deleted = true
      if (!this.uploading) {
        this.deletedCleaner()
      }
    },
    deletedCleaner() {
      for (let i = this.files.length - 1; i >= 0; i--) {
        if (this.files[i].deleted) {
          this.$delete(this.files, i)

          this.addIndx--
          if (this.addIndx < 0) {
            this.addIndx = 0
          }

          this.lastParallelIndex--
          if (this.lastParallelIndex < 0) {
            this.lastParallelIndex = 0
          }
        }
      }
    },
    getHref(link) {
      const l = document.createElement('a')
      l.href = link
      return l
    },
    gifSelected(gif) {
      this.$refs.gifDropdown.hide()

      const newFile = this.createFileFromInput({ name: gif.id })
      const gifHref = this.getHref(gif.images.original.url)

      newFile.attachmentData = {
        content_type: 'giphy',
        domain: gifHref.origin,
        file: gifHref.pathname,
        name: gif.id,
        tags: ['giphy']
      }

      if (gif.user) {
        newFile.attachmentData.giphy_user = gif.user
      }
      newFile.thumb = gif.images.original.url
      newFile.content_type = 'giphy'
      this.gifToSend = newFile

      this.sendMessage()
    },
    addFiles(f) {
      this.filesInput(f)
    },
    sendMessage() {
      if (this.notAbleToSend && this.gifToSend === null) {
        return
      }

      if (
        this.files.length &&
        this.filesToSend.length &&
        this.gifToSend === null
      ) {
        this.files = []
      }

      if (this.sendTimeout) {
        clearTimeout(this.sendTimeout)
        this.sendTimeout = null
      }

      this.errors = {}

      if (this.messageBuffer) {
        let msgBody = this.messageBuffer.body

        if (this.messageText.length) {
          if (msgBody.length) {
            msgBody = msgBody + '\n' + this.messageText
          } else {
            msgBody = this.messageText
          }
        }

        this.messageBuffer.body = msgBody
        if (this.messages[this.messages.length - 1].id === 'pendingmsg') {
          this.messages[this.messages.length - 1].body = msgBody
        }
      } else {
        let msgGroup = 0
        if (this.messages.length) {
          msgGroup = this.messages[this.messages.length - 1].group
          if (
            this.messages[this.messages.length - 1].sender_user_id !==
            this.messageUserId
          ) {
            msgGroup--
          }
        }

        const newMessage = {
          body: this.gifToSend
            ? ''
            : sanitizeHtml(this.messageText, defaultSanitizeHtmlOptions),
          id: 'pendingmsg',
          created: new Date().toISOString(),
          pending: true,
          sender_user_id: this.messageUserId,
          group: msgGroup,
          files: this.gifToSend ? [this.gifToSend] : this.filesToSend
        }
        this.messageBuffer = newMessage

        this.messageBuffer.attachmentsArray = []
        if (this.gifToSend) {
          this.messageBuffer.attachmentsArray.push(
            this.gifToSend.attachmentData
          )
        } else {
          this.messageBuffer.attachmentsArray = this.filesToSend.map(
            file => file.attachmentData
          )
        }

        this.messages.push(this.messageBuffer)

        this.plusReplies++
        if (this.plusReplies === this.pagination.per_page) {
          this.plusPages++
          this.plusReplies = 0
        }
      }

      this.hasPending = true

      this.sendTimeout = setTimeout(() => {
        this.actuallySendMessage()
      }, 100)

      if (this.gifToSend === null) {
        this.messageText = ''
      }

      this.scrollToBottom()
    },
    retryPendingMessage() {
      this.messages[this.messages.length - 1].id = 'pendingmsg'
      this.messageText = ''
      this.retrying = true
      this.disableInput = true
      this.actuallySendMessage()
    },
    relaySubmit() {
      this.relaySend(this.form)
    },
    async actuallySendMessage() {
      if (this.hasPending) {
        this.form.body = this.messageBuffer.body
      } else {
        // it will probably never get here
        this.form.body = this.messageText
      }

      if (
        this.messageBuffer.attachmentsArray &&
        this.messageBuffer.attachmentsArray.length
      ) {
        this.form.attachments = this.messageBuffer.attachmentsArray
      }

      if (
        (this.form.body && this.form.body.length) ||
        (this.form.attachments && this.form.attachments.length)
      ) {
        this.disableSend = true
        this.isLoading = true
        if (!this.showRecaptcha2) {
          try {
            const recaptchaService = this.$dep(RecaptchaService)
            const token = await recaptchaService.getToken('contact_reply')
            this.form.recaptcha_token = {
              v: 3,
              token
            }
            this.submit()
          } catch (e) {
            // this will force-load recaptcha 2
            this.onError({ recaptcha_token: true })
            this.$logger.captureError(e)
          }
        } else {
          this.submit()
          this.showRecaptcha2 = false
        }
      }
    },
    onSuccess() {
      // this.disableSend = false
      if (this.showRecaptcha2) {
        this.showRecaptcha2 = false
      }

      this.messageBuffer = null

      if (this.gifToSend) {
        this.gifToSend = null
      } else {
        this.filesToSend = []
        this.addIndx = 0
        this.lastParallelIndex = 0
      }

      this.form.body = ''
      this.form.recaptcha_token = null
      this.form.attachments = null

      if (this.form.telephone && this.form.telephone.value === null) {
        this.form.telephone = null
      }

      setTimeout(() => {
        this.fetchNewMessages()
      }, 1000)
    },
    onPageChange(pageNum) {
      this.pageNum = pageNum
      this.fetchMessages()
    },
    myDetailsClicked() {
      if (!this.isForGuest) {
        if (!this.loadMyDetails) {
          this.loadMyDetails = true
          this.fetchReply()
        }
      }

      if (this.myDetailsShown) {
        this.closeMyDetails()
      } else {
        this.showMyDetails()
      }
    },
    inputFocused() {
      if (!this.loadMyDetails) {
        this.loadMyDetails = true
        this.fetchReply()
      }
    },
    showMyDetails() {
      this.$refs.cDropdown.show()
    },
    closeMyDetails() {
      this.$refs.cDropdown.hide()
    },
    fetchReply() {
      this.$axios
        .get(`/api/account/messages/${this.messageThread.id}/reply/`)
        .then(response => {
          if (response.status === 200) {
            this.showReplyForm = true

            if (response.data.data.login_as) {
              console.error('LOGIN AS NOT HANDLED')
            } else {
              if (response.data.data.schema === null) {
                this.messageText = ''
                this.disableInput = true
                this.placeHolderText = this.$t('you cannot reply to that user')
                this.buttonText = this.$t('you cannot reply to that user')
              } else {
                this.schema = response.data.data.schema
              }
              if (response.data.data.values) {
                const values = response.data.data.values

                if (values.name) {
                  this.form.name = values.name
                }

                if (values.email) {
                  this.form.email = values.email
                }

                if (values.telephone && values.telephone.telephone) {
                  this.form.telephone = values.telephone
                }
              }
            }

            this.replyFetched = true
          }
        })
        .catch(error => {
          console.error(error)
          this.loadMyDetails = false
        })
    },
    search_close() {
      this.$emit('close-clicked', this.thread)
      this.$emit('toggle-search')
    },
    goToMsg(id) {
      if (
        this.messages.filter(function(e) {
          return e.id === id
        }).length > 0
      ) {
        this.$nextTick(() => {
          const offsetTop = document.getElementById(
            'msg-' + this.messageThread.id + '-' + id
          ).offsetTop
          this.$refs.messagesContainer.scrollTo(0, offsetTop)
        })
      } else {
        this.highlightAfterLoad = id
        this.onPageChange(this.pageNum + 1)
      }
    },
    highlightNext() {
      let indx = this.foundMessagesIDs.indexOf(this.highlight)

      if (indx + 1 === this.foundMessagesIDs.length) {
        indx = -1
      }
      this.highlight = this.foundMessagesIDs[indx + 1]
      this.goToMsg(this.highlight)
    },
    highlightPrev() {
      let indx = this.foundMessagesIDs.indexOf(this.highlight)
      if (indx === 0) {
        indx = this.foundMessagesIDs.length
      }
      this.highlight = this.foundMessagesIDs[indx - 1]

      this.goToMsg(this.highlight)
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const msgCont = this.$refs.messagesContainer
        if (msgCont && msgCont.scrollHeight) {
          if (this.lastMessageId) {
            const elem = document.getElementById(
              'msg-' + this.messageThread.id + '-' + this.lastMessageId
            )
            if (elem.scrollHeight > msgCont.clientHeight) {
              this.goToMsg(this.lastMessageId)
            }
          }
          msgCont.scrollTop = msgCont.scrollHeight
        }
      })
    },
    dateIsDifferent(msg, gindex, mindex) {
      let prevGroupIndex = gindex

      let prevMsgIndex = mindex - 1
      if (prevMsgIndex < 0) {
        if (prevGroupIndex >= 0) {
          prevGroupIndex = gindex - 1
          if (prevGroupIndex < 0) {
            return true // means it's the first message
          }
          prevMsgIndex = this.groupedMessages[prevGroupIndex].length - 1
        } else {
          return false
        }
      }
      const previousMessage = this.groupedMessages[prevGroupIndex][prevMsgIndex]

      const previousDate = format(previousMessage.created, 'd/L/yyyy', {
        locale: this.$i18n.locale
      })
      const currentDate = format(msg.created, 'd/L/yyyy', {
        locale: this.$i18n.locale
      })

      if (previousDate !== currentDate) {
        return true
      }

      return false
    },
    showAvatarAtMessage(msg, gindex, mindex) {
      if (mindex >= this.groupedMessages[gindex].length - 1) {
        let toReturn = 'nulled'
        if (this.idMine(msg.sender_user_id)) {
          if (this.avatar !== null) {
            toReturn = this.avatar
          }
        } else if (this.messageThread.participant.display_photo) {
          toReturn = this.messageThread.participant.display_photo
        }

        return toReturn
      }

      return 'noavatar'
    },
    showReportForMessage(msgId) {
      this.messageToReport = msgId
      this.reportModalVisible = true
    },
    handleVisibilityChange(newVisibilityState) {
      this.reportModalVisible = newVisibilityState
      if (this.handleVisibilityChange === false) {
        this.messageToReport = null
      }
    },
    onDragover(e) {
      e.preventDefault()
      e.stopPropagation()
      this.dropOver = true
    },
    onDragleave(e) {
      e.preventDefault()
      e.stopPropagation()
      this.dropOver = false
    },
    onDrop(e) {
      e.preventDefault()
      e.stopPropagation()
      this.dropOver = false
      this.addFiles(e)
    },
    giphyPopoverShown() {
      this.gifShown = true
      if (this.isPc) {
        this.$refs.giphy.focusInput()
      }
    },
    giphyPopoverHidden() {
      this.gifShown = false
    },
    onCounteroffer() {
      // if (this.inModal) {
      //   this.$emit('counteroffer')
      //   return
      // }

      this.showMakeOfferModal = true
    },
    async onUpdateOffer(offer) {
      this.$emit('update-offer', offer)
      await this.$nextTick()
      setTimeout(async () => {
        this.loading = false // in order to start fetching new messages
        this.hasPending = true
        await this.fetchNewMessages()
      }, 1000)
    },
    async setOfferState(state: OfferState) {
      const offerId = this.messageThread.offer?.id
      if (!offerId) {
        return
      }

      const successCallback = async (offer: ClassifiedOfferEntry) => {
        await this.onUpdateOffer(offer)
      }
      this.loading = true
      await this.$store.dispatch(
        `${CLASSIFIED_VIEW_NS}/setClassifiedOfferState`,
        {
          offerId,
          state,
          successCallback
        },
        { root: true }
      )
      this.loading = false
    }
  },
  setup(props) {
    const { messageThread } = toRefs(props)

    const vm = getCurrentInstance()

    const {
      open: openRelay,
      close: closeRelay,
      status: relayStatus,
      send: relaySend
    } = useWebSocket(messageThread.value.relay_url, {
      onError: vm.proxy.onError,
      onMessage: (_ws, _event) => {
        vm.proxy.onNewMessages()
      }
    })

    return {
      openRelay,
      closeRelay,
      relayStatus,
      relaySend
    }
  }
})
